module.exports = __webpack_public_path__ + "img/max7.e2c9a6b8.jpg";